var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCzechFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5005 0H0V15H22.5005V0Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5005 7.5V15H0L9.45658 7.5H22.5005Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5005 0V7.5H9.45658L0 0H22.5005Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechFlag);
export default __webpack_public_path__ + "static/media/czech-flag.dc9c289e93cdb786dbe7ddcd31b1cd2a.svg";
export { ForwardRef as ReactComponent };